export default `query {
  allPaceComparisons {
    id
    baseProduct {
      id
    }
    windProtection
    weight
    peripheralVision
    model
    lensShape
    lensChange
    imageSku
    frameType
    frameSize
    bestFor
    reviewSummary {
      count
      recommendRate
      averageStars
    }
  }
}`